import React, { useContext } from 'react';

import { Button, ButtonVariant, Icon, Typography, Image } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';
import { imageBase64 } from '@/helpers/fileHelper';

import { RmpcTattooShort } from '@/api/integrations/rmpc/types/types';

import { TattooSearchContext } from '../../context/TattooSearchContext';

import './TattooCardItem.scss';

interface TattooCardItemProps {
  item: RmpcTattooShort;
}

export const TattooCardItem: React.FC<TattooCardItemProps> = ({ item }) => {
  const { handleDetails, isDetailsLoading } = useContext(TattooSearchContext);

  return (
    <div className="tattoo-card">
      <div className="tattoo-card__image-container">
        {item.image ? (
          <Image src={imageBase64(item.image)} alt={`Татуювання ${item.number}`} className="tattoo-card__image" />
        ) : (
          <Icon name="no_image" width={100} height={100} color="middle-grey" />
        )}
      </div>
      <div className="tattoo-card__content">
        <Typography variant="TEXT14" color="graphite" className="tattoo-card__date">
          Додано: {formatDate(item.published_at)}
        </Typography>
        <Button
          variant={ButtonVariant.ICON_GHOST}
          onClick={() => handleDetails(item)}
          className="tattoo-card__button"
          disabled={isDetailsLoading}
        >
          Детальніше <Icon name="arrow_forward" />
        </Button>
      </div>
    </div>
  );
};
